'use client';
import { size, rem } from '@s7/styles';

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
var blockSX = function(theme) {
    var _obj;
    return _extends((_obj = {
        padding: size.rem(32, 16),
        margin: size.rem(0, -12)
    }, _obj[theme.fn.up("md1")] = {
        padding: size.rem(20, 24),
        margin: 0
    }, _obj.borderRadius = rem(16), _obj), theme.fn.border({
        color: "border.divider"
    }));
};
var textFieldStyles = function(theme) {
    var _obj, _obj1;
    return {
        root: (_obj = {
            paddingBottom: 0,
            width: "100%"
        }, _obj[theme.fn.up("md1")] = {
            width: "auto"
        }, _obj),
        wrapper: (_obj1 = {
            display: "flex",
            borderColor: theme.palette.background.content2,
            borderRadius: rem(12)
        }, _obj1[theme.fn.up("md1")] = {
            width: rem(396)
        }, _obj1)
    };
};

export { blockSX, textFieldStyles };
